/**
 * VCB — sonda degli errori del sito.
 *
 * Registra in GA4 tre cose che oggi non sappiamo:
 *   vcb_js_error      errori JavaScript e promesse rifiutate
 *   vcb_page_crash    la pagina precedente e' morta senza chiudersi (renderer OOM)
 *   vcb_empty_results collezione o ricerca che non mostra nessun prodotto
 *
 * Perche' il crash si rileva DOPO e non mentre accade: quando il renderer
 * esaurisce la memoria il processo viene ucciso, e con lui il JavaScript che
 * dovrebbe segnalarlo. L'unico modo e' lasciare un segnale all'avvio e
 * cancellarlo su `pagehide` (che scatta a ogni uscita pulita, navigazione o
 * bfcache). Se al caricamento dopo il segnale e' ancora li', la pagina prima e'
 * morta male.
 *
 * ⚠️ Falsi positivi possibili: chiusura forzata del browser, spegnimento,
 * scheda uccisa dal sistema su mobile. Serve a contare e a capire DOVE, non a
 * dimostrare il singolo caso.
 *
 * Privacy: nessun dato personale. Si manda il PERCORSO senza query string (che
 * puo' contenere termini di ricerca), il messaggio d'errore troncato, e nulla
 * che identifichi la persona.
 *
 * Robustezza: tutto dentro try/catch e con un tetto di eventi per pagina. Una
 * sonda che rompe il sito o inonda GA4 e' peggio di nessuna sonda.
 */
(function () {
  'use strict';

  var CHIAVE = 'vcb_nav';
  // Tetto PER TIPO di evento, non complessivo. Con un tetto unico i tre
  // valori di velocità (che partono sempre) esaurirebbero il budget e gli
  // errori non arriverebbero mai — proprio quelli che ci interessano di più.
  var TETTI = {
    vcb_js_error: 3,      // un loop di errori non deve inondare
    vcb_page_crash: 1,
    vcb_empty_results: 1,
    vcb_web_vitals: 3,    // lcp, cls, inp: uno ciascuno
    vcb_rage_click: 2
  };
  var contati = {};

  function percorso() {
    try {
      return (location.pathname || '/').slice(0, 120); // senza query: puo' contenere ricerche
    } catch (e) {
      return '/';
    }
  }

  /**
   * Ultimo segmento di una URL, SENZA query string.
   * ⚠️ La query va tolta anche qui, non solo da `page_path`: un errore dentro
   * uno script inline ha come `filename` la URL della pagina, quindi su
   * /search?q=... finirebbe in GA4 il termine cercato dall'utente.
   * Trovato provando la sonda il 21/08/2026.
   */
  function senzaQuery(u) {
    try {
      return String(u || '').split('?')[0].split('#')[0].split('/').pop().slice(0, 60);
    } catch (e) {
      return '';
    }
  }

  // Coda: i guasti capitano anche prima che gtag.js sia pronto (anzi, il crash
  // capita proprio all'inizio). Qui si accumulano e si spurgano appena arriva.
  var coda = [];

  function spurga() {
    if (typeof window.gtag !== 'function') return false;
    while (coda.length) {
      var ev = coda.shift();
      try { window.gtag('event', ev[0], ev[1]); } catch (e) { /* ignora */ }
    }
    return true;
  }

  function invia(nome, dati) {
    try {
      var tetto = TETTI[nome] || 2;
      contati[nome] = (contati[nome] || 0) + 1;
      if (contati[nome] > tetto) return;
      dati = dati || {};
      dati.page_path = percorso();
      coda.push([nome, dati]);

      // ⚠️ NON usare dataLayer.push(['event', ...]).
      // Su questo negozio GA4 e' alimentato dai Web Pixels di Shopify e gtag.js
      // arriva dinamicamente: un push in quel formato NON produce alcuna
      // richiesta di rete. Verificato il 25/08/2026 sparando i tre metodi e
      // guardando il traffico:
      //   gtag('event', ...)            -> POST a /g/collect con tid=G-V2BZMC4G4H
      //   dataLayer.push(['event',...]) -> niente
      //   Shopify.analytics.publish()   -> niente verso GA4
      // Per questo la sonda ha taciuto per 28 giorni, crash compreso.
      if (spurga()) return;

      // gtag non c'e' ancora: riprova a intervalli, poi si arrende.
      var tentativi = 0;
      var t = setInterval(function () {
        if (spurga() || ++tentativi > 40) clearInterval(t);
      }, 250);
    } catch (e) {
      /* la sonda non deve mai far cadere la pagina */
    }
  }

  /* ---------------------------------------------- 1. errori JavaScript */
  window.addEventListener('error', function (ev) {
    try {
      if (!ev) return;
      // Gli errori di caricamento risorsa (img/script) non hanno `message`:
      // sono rumore diverso, li marchiamo a parte.
      if (!ev.message && ev.target && ev.target.tagName) {
        invia('vcb_js_error', {
          err_tipo: 'risorsa',
          err_msg: String(ev.target.tagName).slice(0, 20),
          err_src: senzaQuery(ev.target.src || ev.target.href)
        });
        return;
      }
      invia('vcb_js_error', {
        err_tipo: 'script',
        err_msg: String(ev.message || '').slice(0, 100),
        err_src: senzaQuery(ev.filename) + ':' + (ev.lineno || 0)
      });
    } catch (e) {}
  }, true);

  window.addEventListener('unhandledrejection', function (ev) {
    try {
      var r = ev && ev.reason;
      invia('vcb_js_error', {
        err_tipo: 'promessa',
        err_msg: String((r && (r.message || r)) || '').slice(0, 100),
        err_src: ''
      });
    } catch (e) {}
  });

  /* ------------------------------------- 2. la pagina prima e' morta? */
  try {
    var prec = sessionStorage.getItem(CHIAVE);
    if (prec) {
      var p = JSON.parse(prec);
      // Se il segnale e' ancora qui, `pagehide` non e' mai scattato.
      invia('vcb_page_crash', {
        crash_page: String(p.p || '').slice(0, 120),
        crash_durata_s: p.t ? Math.round((Date.now() - p.t) / 1000) : 0
      });
    }
    sessionStorage.setItem(CHIAVE, JSON.stringify({ p: percorso(), t: Date.now() }));
    window.addEventListener('pagehide', function () {
      try {
        sessionStorage.removeItem(CHIAVE);
      } catch (e) {}
    });
  } catch (e) {
    /* sessionStorage puo' essere negato (navigazione privata, cookie bloccati) */
  }

  /* --------------------------------------- 3. pagine senza risultati */
  window.addEventListener('load', function () {
    try {
      var p = percorso();
      if (p.indexOf('/collections/') !== 0 && p.indexOf('/search') !== 0) return;
      // Si guarda la griglia dei risultati, non tutta la pagina: i caroselli
      // di raccomandazione contengono prodotti anche quando la griglia e' vuota.
      var griglia = document.querySelector('#ResultsList, .main-collection-grid');
      if (!griglia) return;
      if (griglia.querySelectorAll('a[href*="/products/"]').length === 0) {
        invia('vcb_empty_results', { tipo: p.indexOf('/search') === 0 ? 'ricerca' : 'collezione' });
      }
    } catch (e) {}
  });

  // ------------------------------------------------------------------
  // VELOCITÀ REALE e INCEPPI
  //
  // Fino a oggi non avevamo NESSUN dato di velocità percepita dagli utenti
  // veri: PageSpeed richiede una chiave, il browser automatizzato non
  // dipinge davvero. Ma la lentezza è la causa silenziosa numero uno
  // dell'abbandono, e non si vede in nessuna metrica di GA4.
  //
  // Qui si misura sul campo, senza librerie:
  //   LCP  quanto ci mette a comparire la cosa piu' grande della pagina
  //   CLS  quanto il contenuto salta mentre carichi
  //   INP  quanto tarda la pagina a rispondere a un tocco
  //
  // I valori vanno anche in fasce ("buono/da_migliorare/scarso") perché una
  // fascia è una DIMENSIONE (basta registrarla), mentre una media richiede
  // una metrica personalizzata. Così il dato è leggibile subito.
  //
  // RAGE CLICK: tre tocchi ravvicinati nello stesso punto. È il gesto di chi
  // preme un bottone che non risponde — l'inceppo allo stato puro.
  // ------------------------------------------------------------------
  function fascia(nome, v) {
    if (nome === 'lcp') return v <= 2500 ? 'buono' : (v <= 4000 ? 'da_migliorare' : 'scarso');
    if (nome === 'inp') return v <= 200 ? 'buono' : (v <= 500 ? 'da_migliorare' : 'scarso');
    return v <= 0.1 ? 'buono' : (v <= 0.25 ? 'da_migliorare' : 'scarso');
  }

  var vitali = {};

  function osserva(tipo, callback) {
    try {
      var po = new PerformanceObserver(function (l) { l.getEntries().forEach(callback); });
      po.observe({ type: tipo, buffered: true });
      return po;
    } catch (e) { return null; }
  }

  try {
    osserva('largest-contentful-paint', function (e) { vitali.lcp = e.startTime; });
    osserva('layout-shift', function (e) {
      if (!e.hadRecentInput) vitali.cls = (vitali.cls || 0) + e.value;
    });
    osserva('event', function (e) {
      if (e.duration > (vitali.inp || 0)) vitali.inp = e.duration;
    });
  } catch (e) { /* browser vecchio: si rinuncia in silenzio */ }

  // Si spedisce a pagina che se ne va: prima i valori non sono definitivi.
  var vitaliInviati = false;
  function inviaVitali() {
    if (vitaliInviati) return;
    vitaliInviati = true;
    try {
      Object.keys(vitali).forEach(function (k) {
        var v = k === 'cls' ? Math.round(vitali[k] * 1000) / 1000 : Math.round(vitali[k]);
        invia('vcb_web_vitals', { vitale: k, valore: v, giudizio: fascia(k, vitali[k]) });
      });
    } catch (e) { /* ignora */ }
  }
  window.addEventListener('pagehide', inviaVitali);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') inviaVitali();
  });

  // ---- rage click ----
  try {
    var ultimi = [];
    document.addEventListener('click', function (ev) {
      var ora = Date.now();
      ultimi.push({ t: ora, x: ev.clientX, y: ev.clientY });
      ultimi = ultimi.filter(function (c) { return ora - c.t < 800; });
      if (ultimi.length < 3) return;
      var a = ultimi[0], b = ultimi[ultimi.length - 1];
      if (Math.abs(a.x - b.x) > 30 || Math.abs(a.y - b.y) > 30) return;
      ultimi = [];
      var t = ev.target || {};
      var etichetta = (t.tagName || '?') +
        (t.id ? '#' + String(t.id).slice(0, 24) : '') +
        (t.className && typeof t.className === 'string'
          ? '.' + t.className.trim().split(/\s+/)[0].slice(0, 24) : '');
      invia('vcb_rage_click', { elemento: etichetta.slice(0, 60) });
    }, true);
  } catch (e) { /* ignora */ }

})();
